import { useParams } from 'react-router-dom';
import { PathParams } from '../../../../../routes/routing-path';
import { useApiActions } from '../../../../../hooks/use-api-actions';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Pos } from '../../../../../models/pos';
import { TrimUiManager } from '../../../../../trim-editor/manager/ui/trim.ui.manager';
import { TrimTempModel } from '../../../../../trim-editor/model/trim.temp-model';
import { Env } from '../../../../../models/env';
import { ApiGetTemplates } from '../../../../../api/sift/back/api-templates';
import { dialogActions } from '../../../../dialog/slice/dialog-slice';
import { XmlParser } from '../../../../../manager/xml-parser';
import { usePrintOrder } from '../../hooks/use-print-order';
import { PrintDataStructure, PrintItemDataEntity } from '../../../../../models/sift/json/print-model';
import { TrimEditableImage } from '../../../../../trim-editor/manager/image-edit/trim.editable-image';
import {
  ApiPrintImagesGet,
  PrintImagesDataEntity,
  PrintImagesGetResponse,
} from '../../../../../api/sift/front/api-print-image';
import { cloneDeep } from 'lodash';
import {
  TrimEditableImageManager
} from '../../../../../trim-editor/manager/editable-image/trim.editable-image.manager';
import * as lodash from 'lodash';
import { ScreenColorType } from '../../../layout/menu/layout.menu';
import { layoutActions } from '../../../../../slices/layout-slice';
import { TrimPrintManager } from '../../../../../trim-editor/print/trim.print';
import { localStorageActions } from '../../../../../slices/local-storage-slice';

export const INIT_PRINT_MENU: PrintTrimMenuType = {
  modeAbleArea: 'on',
  modeInOut: 'out',
  screenColor: 'black',
  isAllowMargin: false,
};

export type ModeInOutType = 'in' | 'out' | 'eq';

export type PrintTrimMenuType = {
  modeAbleArea: 'on' | 'off',
  modeInOut: ModeInOutType,
  screenColor: ScreenColorType,
  isAllowMargin: boolean,
}

export type TrimPrintDetailType = {
  brandName: string,
  paperName: string,
  borderName: string,
  lamiName: string,
  orderId: string,
  tapeName: string,
  matName: string,
}

const UsePrintTrim = () => {
  const { kijshopCd, shopOrderId, orderId, imageId } = useParams<PathParams>();
  const { asyncApiRun } = useApiActions();
  const dispatch = useAppDispatch();
  const { getData, getMetaData } = usePrintOrder();
  const { dialogs, localStorage } = useAppSelector((state) => ({
    dialogs: state.dialog.dialogs,
    localStorage: state.storage,
  }), lodash.isEqual);

  // - State -
  // -- 人寸トリミングメニューの開閉状態 --
  const [trimMenu, setTrimMenu] = useState(false);
  // -- 通信中フラグ --
  const [connectingMessage, setConnectingMessage] = useState('');
  const [connectingMessage2, setConnectingMessage2] = useState('');
  // -- サムネの拡大率 --
  const [textPos, setText] = useState<Pos | null>(null);
  // const [menuParam, setMenuParam] = useState<PrintTrimMenuType>(INIT_PRINT_MENU);

  const [template, setTemplate] = useState<TrimTempModel | null>(null);
  const [structure, setStructure] = useState<PrintDataStructure | null>(null);
  const [selectImage, setSelectImage] = useState<TrimEditableImage | null>(null);
  const [item, setItem] = useState<PrintItemDataEntity | null>(null);
  const [lastName, setLastName] = useState('');
  const [deliveryType, setDeliveryType] = useState<'store' | 'private'>('store');
  const [printDetail, setPrintDetail] = useState<TrimPrintDetailType>({
    brandName: '',
    paperName: '',
    borderName: '',
    lamiName: '',
    orderId: '',
    tapeName: '',
    matName: '',
  });
  const [isRotateTemp, setIsRotateTemp] = useState(false);
  const menuParam = useRef<PrintTrimMenuType>(INIT_PRINT_MENU);
  // const { getEditableImages, images } = usePrintImages(structure ? {structure} : undefined)

  const loadTemplate = useCallback(async (structure: PrintDataStructure) => {
    const BASE_URL = `${Env.api.back.protocol}://${Env.api.back.host}/templates`;
    const item = structure.getItemList().find(v => v.id === orderId);
    if (!item) return;
    setItem(item);
    const itemMeta = item.productData?.meta;
    console.log(itemMeta);
    if (itemMeta) {
      menuParam.current = {
        modeAbleArea: 'on',
        modeInOut: TrimPrintManager.getTrimBaseType(itemMeta.trimBaseType),
        isAllowMargin: itemMeta.layoutMargin,
        screenColor: 'black'
      }
      // setMenuParam({
      //   modeAbleArea: 'on',
      //   modeInOut: getTrimBaseType(itemMeta.trimBaseType),
      //   isAllowMargin: itemMeta.layoutMargin,
      //   screenColor: 'black'
      // })
    }
    const image = item.images.find(v => v.id === imageId);
    const itemId = item.productData?.ProductDetailItemData.itemId;
    const edgeDtempId = item.productData?.meta?.borderType;

    if (!image || !itemId) return;
    const directFlg = !Number(image.rotate) ? '1' : '2';
    const printDateFlg = !!item.productData?.itemSetting.printDate;
    // const printDateFlg = image.datePrint;
    if (item.templates) {
      // const template = structure.getTemplate(item.id, directFlg, true);
      const template = structure.getTemplate(item.id, directFlg, printDateFlg);
      await getImages();
      setTemplate(template.template);
      setStructure(structure);
      return;
    }

    const res = await asyncApiRun(new ApiGetTemplates({itemId, edgeDtempId, directFlg: Number(directFlg)}));
    await getImages();
    const target = res.templateGroupData.find(v => v.directFlg === directFlg);

    if (!target) {
      setTemplate(null);
      dispatch(dialogActions.pushMessage({
        title: '確認',
        message: ['テンプレートが見つかりませんでした。', '時間をおいてトリミングを再度お試しください'],
        buttons: [{
          label: 'OK',
          callback: () => {
            dispatch(dialogActions.pop());
            // TODO: 画面遷移追加
          },
        }],
      }));
      return;
    };
    return fetch(
      `${BASE_URL}/${target.hpsTppath}/template.xml`,
      { method: 'GET', mode: 'cors' },
    ).then(res => res.text())
      .then(async (body) => {
        console.log(body);
        const temp = await new XmlParser().parse<TrimTempModel>(body);
        setTemplate(temp)
        setStructure(structure);
      });
  }, [orderId, imageId, structure, item])

  const createPrintDetail = useCallback((item: PrintItemDataEntity) => {
    const { productData } = item;
    if (!productData) return;
    const { ProductDetailItemData, meta, itemElements, additional } = productData;
    const { itemName  } = ProductDetailItemData;
    if (!meta) return;
    const { paperType, borderType, laminateType, additionalInfo, additionalInfo2 } = meta;
    const paperName = itemElements.find(v => v.progFlg === 'paper')?.list.find(v => v.dataId === paperType)?.dataName ?? '';
    const borderName = itemElements.find(v => v.progFlg === 'edgeDtemp')?.list.find(v => v.dataId === borderType)?.dataName ?? '';
    const lamiName = itemElements.find(v => v.progFlg === 'laminate')?.list.find(v => v.dataId === laminateType)?.dataName ?? '';
    const tapeName = additional?.info1.find(v => v.additionalInfoId === additionalInfo)?.additionalInfoName ?? '';
    const matName = additional?.info2.find(v => v.additionalInfo2Id === additionalInfo2)?.additionalInfo2Name ?? '';
    setPrintDetail({
      brandName: itemName,
      paperName,
      borderName,
      lamiName,
      orderId: shopOrderId,
      tapeName,
      matName,
    })
  }, [orderId]);

  // - effect -
  useEffect(() => {
    // リセット ( window.location.reload ) 直行時はReduxが未復元のため、プリセットリスト等をlocalStorageから復元する
    if (localStorage.kijshopCd !== kijshopCd || localStorage.kijshopCd === '') {
      dispatch(localStorageActions.getLocalData(kijshopCd));
    }
    // if (!localStorage.isReloaded) {
    //   dispatch(localStorageActions.setIsReloaded(true));
      // window.location.reload();
    // } else {
    //   dispatch(localStorageActions.setIsReloaded(false));
    // }
    getData().then(async (res) => {
      console.log(res);
      const _structure = res.meta;
      setDeliveryType(_structure.deliveryData?.type === 'customer' ? 'private' : 'store');
      await loadTemplate(_structure);
      const item = _structure.getItemList().find(v => v.id === orderId);
      if (!item) return;
      createPrintDetail(item);
      setIsRotateTemp(!!item.templates?.length)
    })
    getMetaData().then(res => {
      setLastName(res.lastName);
      console.log(res);
    })
    // const thumbMng = new TrimThumbManager();
    // thumbMng.makeThumbOutCanvas({kijshopCd, orderId, shopOrderId, itemId: 'jpit305606', directFlg: '1'})
    //   .then(url => {
    //     console.log(url);
    //     if (!url) return;
    //     const a = document.createElement("a"); // `a` タグを作成
    //     a.href = url;
    //     a.download = 'test'; // ダウンロードするファイル名を指定
    //     document.body.appendChild(a);
    //     a.click(); // 自動クリック
    //     document.body.removeChild(a);
    //     URL.revokeObjectURL(url); // メモリ解放
    //   })

    TrimUiManager.ins.on('t->r:open-trim-menu', (e) => {
      setTrimMenu(e.isOpen);
    });
    TrimUiManager.ins.on('t->r: post-text-pos', setTextPos);
    TrimUiManager.ins.on('t->r:wait-loading', (e) => setConnectingMessage(e.message));
    TrimUiManager.ins.on('t->r:wait-loading2', (e) => setConnectingMessage2(e.message));
    TrimUiManager.ins.on('r->t:change-screen-color', (e) => {
      menuParam.current = e;
    });
    return () => {
      TrimUiManager.ins.off('t->r: post-text-pos', setTextPos);
      TrimUiManager.ins.off('t->r:open-trim-menu');
      TrimUiManager.ins.off('t->r:wait-loading');
      TrimUiManager.ins.off('t->r:wait-loading2');
    TrimUiManager.ins.off('r->t:change-screen-color');
    }
  }, []);

  // - callback -
  const createEditableImage = useCallback((
    request: PrintImagesDataEntity,
  ) => {
    TrimUiManager.ins.emit('r->t:trim-add-image:restore', {
      kijshopCd,
      shopOrderId,
      onSuccess: (v) => {
        setSelectImage(v)
      },
      onError: () => {},
      data: request,
    })
  }, [
    kijshopCd,
    shopOrderId,
  ]);

  // 画像一覧の取得
  const getImages = useCallback((
    param?: {
      callback?: {
        onError?: (e: any) => void;
      }, options?: {
        apiName?: string;
        ignoreSystemError?: boolean;
        ignoreTimeout?: boolean;
      },
      ignoreCreateEditableImage?: boolean,
    },
  ) => {
    return new Promise<PrintImagesGetResponse>((resolve, reject) => {
      asyncApiRun(
        new ApiPrintImagesGet({ kijshopCd, shopOrderId }),
        param?.callback,
        {
          ...param?.options,
          ignoreSystemError: param?.options?.ignoreSystemError ?? true,
        }
      ).then((res) => {
        resolve(res);
        if (!param?.ignoreCreateEditableImage) {
          const target = res.fileList.find(v => v.id === imageId);
          if (target) {
            const editableImg = TrimEditableImageManager.ins.list.find(v => v.id === target.id);
            editableImg?.editable ? setSelectImage(editableImg) : createEditableImage(target);
          }
        }
      }).catch((e) => reject(e));
    });
  }, [
    kijshopCd, shopOrderId,
    asyncApiRun,
    createEditableImage,
  ]);

  /* trimmingController コールバック */
  const handlerCloseTrimmingController = useCallback(() => {
    TrimUiManager.ins.emit('r->t:close-trim-menu');
    setTrimMenu(false);
  }, []);

  const setTextPos = useCallback((param: { pos: Pos }) => {
    setText(cloneDeep(param.pos));
  }, []);

return {
  kijshopCd,
  trimMenu,
  menuParam,
  textPos,
  template,
  structure,
  selectImage,
  handlerCloseTrimmingController,
  connectingMessage,
  connectingMessage2,
  dialogs,
  item,
  printDetail,
  deliveryType,
  lastName,
  isRotateTemp,
}
}

export default UsePrintTrim;
